import { render, staticRenderFns } from "./Ic_dropdown.vue?vue&type=template&id=212c111a&"
import script from "./Ic_dropdown.vue?vue&type=script&lang=js&"
export * from "./Ic_dropdown.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports